import React, { PropTypes } from 'react';

const NoEntriesDetail = ({ children }) => {
  return <p>{children}</p>;
};

NoEntriesDetail.propTypes = {
  text: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

export default NoEntriesDetail;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/NoEntries/NoEntriesDetail/index.js
 **/